import { ITag, SongType } from 'services/api/entities';
import { Song } from 'services/store/songs/types';

const getFirstMoods = (song: Song, amount: number): ITag[] => {
  const { songType } = song;
  if (songType !== SongType.FREE && songType !== SongType.CUSTOMIZABLE) {
    return [];
  }
  // @ts-ignore
  return song.moods.slice(0, amount);
};

export default getFirstMoods;
